"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */
function getTimeStamp() {
    const dateObject = new Date();
    const date = `0${dateObject.getDate()}`.slice(-2);
    const month = `0${dateObject.getMonth() + 1}`.slice(-2);
    const year = dateObject.getFullYear();
    const hours = `0${dateObject.getHours()}`.slice(-2);
    const minutes = `0${dateObject.getMinutes()}`.slice(-2);
    const seconds = `0${dateObject.getSeconds()}`.slice(-2);
    const milliseconds = `00${dateObject.getMilliseconds()}`.slice(-3);
    return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}
function safeStringify(obj, indent = 2) {
    let cache = [];
    const retVal = JSON.stringify(obj, (key, value) => typeof value === "object" && value !== null
        ? cache.includes(value)
            ? undefined // Duplicate reference found, discard key
            : cache.push(value) && value // Store value in our collection
        : value, indent);
    cache = [];
    return retVal;
}
function generateLogText(message, ...params) {
    const messageText = safeStringify(message);
    if (params) {
        const paramsText = safeStringify(params);
        return `${getTimeStamp()} ${messageText} | ${paramsText}`;
    }
    return `${getTimeStamp()} ${messageText}`;
}
exports.default = {
    info: (message, ...params) => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.NODE_ENV === 'development') {
            console.info(`INF: ${generateLogText(message, ...params)}`);
        }
    }),
    error: (message, ...params) => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.NODE_ENV === 'development') {
            console.error(`ERR: ${generateLogText(message, ...params)}`);
        }
    }),
    warn: (message, ...params) => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.NODE_ENV === 'development') {
            console.warn(`WRN: ${generateLogText(message, ...params)}`);
        }
    }),
    success: (message, ...params) => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.NODE_ENV === 'development') {
            console.log(`SUC: ${generateLogText(message, ...params)}`);
        }
    }),
    debug: (message, ...params) => __awaiter(void 0, void 0, void 0, function* () {
        if (process.env.NODE_ENV === 'development') {
            console.debug(`DBG: ${generateLogText(message, ...params)}`);
        }
    }),
};
